import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Help from '../../generics/help';
import swal from 'sweetalert';
import { Panel } from 'react-bootstrap';
import moment from 'moment';
import Parser from 'html-react-parser';
import $ from 'jquery';
import {bin} from 'react-icons-kit/icomoon/bin';
import SvgIcon from 'react-icons-kit';

var Config = require('../../../config');

class QualityControl extends Component{
    constructor(props){
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onSave = this.onSave.bind(this);
        this.delete_list = this.delete_list.bind(this);
        this.unit_search = this.unit_search.bind(this);

        this.state = {
            bc_id: "",
            unit_number:"",
            components:[],
            data:{},
            open_date:false,
            year:moment().format('YYYY'),
            mounth:moment().format('M'),
            years:[],
            mounths:[
                {value:"1", text:"Enero"},
                {value:"2", text:"Febrero"},
                {value:"3", text:"Marzo"},
                {value:"4", text:"Abril"},
                {value:"5", text:"Mayo"},
                {value:"6", text:"Junio"},
                {value:"7", text:"Julio"},
                {value:"8", text:"Agosto"},
                {value:"9", text:"Septiembre"},
                {value:"10", text:"Octubre"},
                {value:"11", text:"Noviembre"},
                {value:"12", text:"Diciembre"}
            ]
        }
    }
    

    componentDidMount(){
        
        fetch(Config.default.apiGateway.URL+'clinic_history/years_has_hc?health_facilities_id='+sessionStorage.getItem('health_facilities_id'), {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					years: response
				});
			}
        });
        
        fetch(Config.default.apiGateway.URL+'blood_component/quality_control',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			this.setState({
		      components: response
		    });
        });


        $(document).off().on('keyup', 'input', function(e){
            var unit_id = $(this).parent('div').attr('unit_id');
            var decimals = $(this).parent('div').attr('decimals') !== undefined ? parseInt($(this).parent('div').attr('decimals')) : 2;
            var t = e.target.value;
            e.target.value = (t.indexOf(".") >= 0) ? (t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), (decimals+1))) : t;
            var formula = null;

            const inputs = $('#'+unit_id).find('input, select');

            $.each(inputs, function(i, input){
                formula = $(this).parent('div').attr('formula');
                
                if(formula !== undefined && formula !== ""){
                    var str = formula.split('&');

                    $(this).val(getTerm(str, inputs));
                    
                }else{
                    var min = parseFloat($(this).attr('min'));
                    var max = parseFloat($(this).attr('max'));
                    var val = $(this).val() !== "" ? parseFloat($(this).val()) : 0;

                    if(val < min || val > max){
                        $(this).addClass('error');
                    }else{
                        $(this).removeClass('error');
                    }
                    
                    
                    
                }
                
            });
        });       

        const getTerm = (term, inputs)=>{
            var result = "";
            var formula = "";
            for (var i = 0; i < term.length; i++) {
                var id = parseFloat( term[i] );
                var value = '';
                if (!isNaN(id)) {
                    inputs.each(function(i){
                        if(id === parseInt($(this).attr('id'))){
                            formula = formula + $(this).val();
                        }
                    });                   
                }else {
                    formula = formula + term[i];
                };
            };

            try{
                result =  eval(formula);
            }catch(e){
                //swal('Error', 'Verifique todos sus valores antes de calcular','error');
                return "";
            }

            if (!isNaN(result)) {
                return (result).toFixed(2);
            } else{
                return "";
            };
        }
        
    }

    componentDidUpdate(){
        
        
        
    }

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});

        if(e.target.name === 'bc_id' && e.target.value !== ""){
            setTimeout(()=>{
                this.onSearch();
            }, 500);
            
        }
    }

    onSearch(){
        this.props.waiting.handleShow('Cargando...');
        fetch(Config.default.apiGateway.URL+'quality_control?hf_id='+sessionStorage.getItem('health_facilities_id')+
            '&year='+this.state.year+'&month='+this.state.mounth+'&bc_id='+this.state.bc_id, {
            method:'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            this.props.waiting.handleClose();
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg)=>{
                    swal('Error', msg, 'error');
                });
            }
        }).then(response => {
            if(response !== undefined){
                this.setState({data: response});

                setTimeout(()=>{
                    response.units.map((r)=>{
                        const inputs = $('#'+r.unit_id).find('input, select');

                        $.each(inputs, function(input, i){
                            var id = parseInt($(this).attr('id'));
    
                            var index = r.values.findIndex(obj => obj.quality_field_id === id);
    
                            if(index !== -1){
                                $(this).val(r.values[index].value);    
                            }
                            
                        });
                        
                    })
                }, 500);
            }
        })
    }

    onSave(e, id){
        const inputs = $('#'+id).find('input, select');
        var obj = {
            unit_id: id,
            fields:[]
        };
        var error = false;
        $.each(inputs, function(input, i){
            var value = $(this).val();
            var id = $(this).attr('id');

            if(value !== "" && value !== null){
                obj.fields.push({
                    field_id: id,
                    value: value
                });
            }

            if($(this).attr('class').indexOf('error') !== -1){
                error = true;
            }
        });
        if(error){
            swal('Error', 'Valores fuera de los limites, marcados en rojo', 'error');
        }else if(obj.fields.length > 0){
            this.props.waiting.handleShow('Guardando...');
            fetch(Config.default.apiGateway.URL+'quality_control',{
                method:'POST',
                body:JSON.stringify(obj),
                headers: new Headers({
                    "Authorization" : 'Bearer '+sessionStorage.getItem('token'),
                    "Accept"        : 'application/json',
                    "Content-Type"  : 'application/json'
                })
            }).then((res)=>{
                this.props.waiting.handleClose();
                if(res.ok){
                    return res.json();
                }else{
                    res.text().then((msg => {
                        swal('Error', msg, 'error');
                    }));
                }
            }).then(response => {
                if(response !== undefined){

                }
            });
        }else{
            swal('Error', 'Debe agregar por lo menos un valor', 'error');
        }
        
    }

    delete_list(e, i){
        var data = this.state.data;

        data.units.splice(i, 1);

        this.setState({data});
    }

    unit_search(){
        this.props.waiting.handleShow('Cargando...');
        fetch(Config.default.apiGateway.URL+'quality_control?hf_id='+sessionStorage.getItem('health_facilities_id')+
            '&bc_id='+this.state.bc_id+'&unit_number='+this.state.unit_number, {
            method:'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            this.props.waiting.handleClose();
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg)=>{
                    swal('Error', msg, 'error');
                });
            }
        }).then(response => {
            if(response !== undefined){
                var data = this.state.data;

                if(response.length > 0){
                    var index = this.state.data.units.findIndex(obj => 
                        obj.unit_id === response[0].unit_id
                    );
                    
                    if(index === -1){
                        data.units.push(response[0]);
                    }

                    
                    this.setState({data: data, unit_number:""});
                    setTimeout(()=>{
                        data.units.map((r)=>{
                            const inputs = $('#'+r.unit_id).find('input, select');

                            $.each(inputs, function(input, i){
                                var id = parseInt($(this).attr('id'));
        
                                var index = r.values.findIndex(obj => obj.quality_field_id === id);
        
                                if(index !== -1){
                                    $(this).val(r.values[index].value);    
                                }
                                
                            });
                            
                        })

                        setTimeout(()=>{
                            var h = $('.card').height();
                            
                            if(h !== undefined){
                                $('.card').css('height', h);
                            }
                        }, 1000);
                    }, 500);
                }
                
                
                
            }
        })
    }

    render(){
        const {t} = this.props;
        return(
            <div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						Control de Calidad ->
						Control de Calidad
					</h5>
				</div>
				
                <Help 
                    {...this.props}
                    menu={"help_processed"} 
                    submenu={"help_reconstitution"}  />
				<div className="form-group">
                    <div className="col-xs-12 form-group">
                        <div className="col-xs-12 col-sm-3">
                            <input type="checkbox" name="open_date" id="open_date" value={this.state.open_date} 
                                checked={this.state.open_date} onChange={(e)=>this.setState({open_date: !this.state.open_date})} /> <span>Abrir Fechas</span>
                        </div>
                    </div>
                    <div className="col-xs-12 form-group">
                        <div className="col-xs-12 col-sm-1">
                            <span className="span-min">Año</span>
                            <select className="form-control input-sm" name="year" id="year" value={this.state.year}
                                onChange={(e)=>this.handleChange(e)} disabled={!this.state.open_date}>
                                    {this.state.years.map((y, i)=>
                                        <option key={i} value={y}>{y}</option>
                                    )}
                                </select>
                        </div>
                        <div className="col-xs-12 col-sm-1">
                            <span className="span-min">Mes</span>
                            <select className="form-control input-sm" name="mounth" id="mounth" value={this.state.mounth}
                                onChange={(e)=>this.handleChange(e)} disabled={!this.state.open_date}>
                                    {this.state.mounths.map((m, i)=>
                                        <option key={i} value={m.value}>{m.text}</option>
                                    )}
                                </select>
                        </div>
                        <div className="col-xs-12 col-sm-3">
                            <span className="span-min">Componente</span>
                            <select className="form-control input-sm" name="bc_id" id="bc_id" value={this.state.bc_id}
                                onChange={(e)=>this.handleChange(e)}
                            >
                                <option value="">Seleccione...</option>
                                {this.state.components.map((c, i)=>
                                    <option key={i} value={c.id}>{c.component}</option>
                                )}
                            </select>
                        </div>
                    </div>
                    <div className="col-xs-12 form-group">
                        <div className="col-xs-12 col-sm-2">
                            <span className="span-min">Número de Unidad</span>
                            <input className="form-control input-sm" name="unit_number" id="unit_number"
                                value={this.state.unit_number} onChange={(e)=>this.handleChange(e)} />
                        </div>
                        <div className="col-xs-12 col-sm-1" style={{marginTop:22}}>
                            <button className="btn btn-info" onClick={this.unit_search}>Buscar</button>
                        </div>
                    </div>

                    <div className="col-xs-12 form-group">
                        {this.state.data.units !== undefined &&
                            this.state.data.units.map((c, i)=>
                                <div key={i} className="col-xs-12 col-sm-4">
                                    <Panel className="card"> 
                                        <Panel.Body>
                                            <div className="col-xs-12">
                                                <div className="form-group" style={{textAlign:'right'}}>
                                                    <button className="btn btn-info" onClick={(e)=>this.delete_list(e, i)}>
                                                        <SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
                                                    </button>
                                                </div>
                                                <div className="form-group">
                                                    <div>
                                                        <label>Componente: </label><span style={{marginLeft:8}}>{c.component}</span>
                                                    </div>
                                                    <div>
                                                        <label>Número de Unidad: </label><span style={{marginLeft:8}}>{c.number}</span>
                                                    </div>
                                                    <div>
                                                        <label>Volumen de Unidad: </label><span style={{marginLeft:8}}>{c.volume+' ml'}</span>
                                                    </div>
                                                    <div>
                                                        <label>Fecha de Extracción: </label><span style={{marginLeft:8}}>{moment(c.extraction_date).format('DD/MM/YYYY HH:mm')}</span>
                                                    </div>
                                                    <div>
                                                        <label>Estatus de Unidad: </label><span style={{marginLeft:8}}>{c.status}</span>
                                                    </div>                                            
                                                </div>
                                                <div className="form-group" id={c.unit_id}>
                                                    {this.state.data.component_fields.map((d, j)=>
                                                        <div key={j} className="form-group" formula={d.formula} unit_id={c.unit_id} decimals={d.decimals}>
                                                            <span className="span-min">{d.field_label}</span>
                                                            {Parser(d.html)}
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="form-group">
                                                    <button className="btn btn-info" onClick={(e)=>this.onSave(e, c.unit_id)}>Guardar/Editar</button>
                                                </div>
                                            </div>
                                            
                                        </Panel.Body>
                                    </Panel>
                                </div>
                            )
                        }
                        
                    </div>
                </div>
            </div>
        )
    }

}

export default translate('translations')(QualityControl);